import React from "react"
import { Table as AntTable } from "antd"
import { ExtraButtons } from "src/components/extra-buttons"
import { Header } from "src/components/layout/header"
import { TableSearch } from "src/components/table-search"
import { VisibilityProvider } from "src/components/visibility-provider"
import { useUpdateHeaderTitle, usePermission } from "src/hooks"
import { EditDrawer } from "src/pages-lib/roles/edit-drawer"
import { useGetData, useManageItems } from "src/pages-lib/roles/model"
import { getColumns } from "src/pages-lib/roles/table-columns"
import styled from "styled-components"

export default function Roles() {
  const { hasPermission } = usePermission()
  const [createDrawerState, setCreateDrawerState] = React.useState(false)
  const [editDrawerState, setEditDrawerState] = React.useState(false)

  const {
    dataItems,
    dataItemsColumns,
    pagination,
    isLoading,
    handleTableChange,
    handleSearchTable,
    refetch: getItems,
    permissionOptions,
  } = useGetData()

  const { editData, resetData, onSaveEdit, onCreate, onDelete, onEditItem } =
    useManageItems(dataItems, getItems, onSuccessEdit, onSuccessCreate)

  const headerTitle = useUpdateHeaderTitle({
    items: dataItems,
    defaultTitle: "0 Ролей",
    arrType: ["Ролей", "Роль", "Ролей"],
  })

  const columns = getColumns(hasPermission("roles.edit") ? onEditItem : null, hasPermission("roles.delete") ? onDelete : null)

  function onSuccessEdit() {
    setEditDrawerState(!editDrawerState)
  }

  function onSuccessCreate() {
    setCreateDrawerState(!createDrawerState)
  }

  return (
    <>
      <Header
        title={headerTitle}
        extra={
          <ExtraButtons
            onCreate={hasPermission("roles.create") ? () => setCreateDrawerState(true) : undefined}
            titles={{ onCreate: "Добавить роль" }}
          />
        }
      />
      <TableSearch handleSearch={handleSearchTable} placeholder={"Поиск по ID, названию или слагу"} />
      <StyledTable
        dataSource={dataItemsColumns}
        columns={columns}
        loading={isLoading}
        onChange={handleTableChange}
        pagination={pagination}
      />

      {hasPermission("roles.create") && (
        <VisibilityProvider visible={createDrawerState}>
          <EditDrawer
            onSave={onCreate}
            onClose={() => setCreateDrawerState(false)}
            title={"Создание роли"}
            visible={createDrawerState}
            permissionOptions={permissionOptions}
          />
        </VisibilityProvider>
      )}

      {hasPermission("roles.edit") && (
        <VisibilityProvider visible={editDrawerState}>
          <EditDrawer
            onSave={onSaveEdit}
            onClose={() => {
              setEditDrawerState(false)
              resetData()
            }}
            initialValues={editData}
            title={"Редактирование роли"}
            visible={editDrawerState}
            permissionOptions={permissionOptions}
          />
        </VisibilityProvider>
      )}
    </>
  )
}

const StyledTable = styled(AntTable)`
  .row-can-view {
    cursor: pointer;
  }
`
